import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Trash2 } from "lucide-react";
import { Textarea } from "../ui/textarea";
import { api, formatApiError } from "../../lib/api";

export const LeadNotes = ({ lead, onChange }) => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const notes = Array.isArray(lead?.notes) ? lead.notes : [];

  const add = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/quotes/${lead.id}/notes`, { text });
      onChange([...notes, data]);
      setText("");
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const remove = async (id) => {
    try {
      await api.delete(`/admin/quotes/${lead.id}/notes/${id}`);
      onChange(notes.filter((n) => n.id !== id));
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail));
    }
  };

  return (
    <div className="mt-8" data-testid="lead-notes">
      <p className="font-mono-d text-[11px] uppercase tracking-[0.18em] text-[#52635B] mb-2">Private notes</p>
      <Textarea value={text} onChange={(e) => setText(e.target.value)} maxLength={4000} placeholder="Call outcome, plans recommended, next steps…" className="min-h-[90px] rounded-xl bg-white" data-testid="lead-note-input" />
      <button onClick={add} disabled={busy || !text.trim()} data-testid="lead-note-add-btn" className="mt-2 inline-flex items-center gap-2 rounded-full bg-[#0B281E] text-[#FAF8F5] px-5 py-2 text-sm font-semibold disabled:opacity-50">
        {busy && <Loader2 className="w-4 h-4 animate-spin" />} Add note
      </button>
      <ul className="mt-5 flex flex-col gap-3">
        {[...notes].reverse().map((n) => (
          <li key={n.id} className="group rounded-xl bg-white border border-[#0B281E]/10 p-4" data-testid={`lead-note-${n.id}`}>
            <div className="flex items-start justify-between gap-3">
              <p className="text-sm text-[#1A2621] whitespace-pre-wrap break-words">{n.text}</p>
              <button onClick={() => remove(n.id)} aria-label="Delete note" data-testid={`lead-note-delete-${n.id}`} className="text-[#52635B] hover:text-[#B91C1C] transition-colors shrink-0"><Trash2 className="w-4 h-4" /></button>
            </div>
            <p className="text-[11px] text-[#52635B] mt-2">{new Date(n.created_at).toLocaleString()}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};
